<template>
  <div>
    <Alert v-bind="alertOptions" v-model="alertOptions.show" />
    <Loading :isLoading="isLoading" />
    <LongWork :taskQueue="longWork" />
  </div>
</template>

<script>
import dialogStore from './miniStore';
import Alert from './Alert.vue';
import Loading from './Loading.vue';
import LongWork from './LongWork.vue';

export default {
  components: { Alert, Loading, LongWork },
  computed: {
    isLoading() {
      return dialogStore.getters.isLoading;
    },
    alertOptions() {
      return dialogStore.state.popup;
    },
    longWork() {
      return dialogStore.state.longWork;
    },
  },
};
</script>

<style></style>
